import ErrorModal from './ErrorModal';

export interface OrderConfirmationFailedModalProps {
  message: string;
}

export default function OrderConfirmationFailedModal({ message }: OrderConfirmationFailedModalProps) {
  return <ErrorModal title="Bekräftelse misslyckades!" message={message} />;
}
